<gplus-input
  class="third-group"
  type="time"
  [control]="timeForm?.controls?.['hours']"
  [label]="'EditPreparationTimeTimeLabel' | translate"
  [placeholder]="'EditPreparationTimeTimePlaceholder' | translate"
/>

<gplus-datepicker
  class="second-group"
  mode="single"
  [instanceId]="'detail-page-form'"
  [control]="timeForm?.controls?.['date']"
  [label]="'EditPreparationTimeDateLabel' | translate"
  [placeholder]="'EditPreparationTimeDatePlaceholder' | translate"
/>

<div class="actions-btns">
  <cw-button button-color="secondary" variant="outlined" (click)="closeDialog()">
    {{ 'EditPreparationTimeCancelBtn' | translate }}
  </cw-button>

  @if (timeForm.invalid || timeForm.pristine) {
    <!-- Disabled -->
    <cw-tooltip [content]="'EditPreparationTimeNothingToSave' | translate" placement="bottom">
      <cw-button
        data-test="prepared-time-submit-btn"
        button-color="accent"
        variant="filled"
        [disabled]="true"
        type="submit"
      >
        {{ 'EditPreparationTimeSubmitBtn' | translate }}
      </cw-button>
    </cw-tooltip>
  } @else {
    <!-- Enabled -->
    <cw-button
      data-test="prepared-time-submit-btn"
      button-color="accent"
      variant="filled"
      (click)="submit()"
      type="submit"
    >
      {{ 'EditPreparationTimeSubmitBtn' | translate }}
    </cw-button>
  }
</div>
